import axios from 'axios';

const iflexApi = axios.create({
  baseURL: process.env.REACT_APP_IFLEXAPI_URL,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
  },
  withCredentials: true,
});

export default iflexApi;
